// stores/useCartStore.js
import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useUserStore } from '@/stores/userStore'
import axios from 'axios'

export const useCartStore = defineStore('cart', () => {
  const carrito = ref([])
  const mostrarCarrito = ref(false)

  const subtotal = ref(0)
  const pesoTotal = ref(0)
  const pesoTotalKg = ref(0)
  const bloquesEnvio = ref(0)
  const envio = ref(0)
  const total = ref(0)

  const apiUrl = process.env.VUE_APP_API_URL || 'http://localhost:8080'

  const cargarDelServidor = async () => {
    const userStore = useUserStore()

    if (!userStore.isAuthenticated || !userStore.user.user.idUser) return

    const res = await axios.get(`${apiUrl}/cart/get/${userStore.user.user.idUser}`)

    carrito.value = res.data.items || []
    subtotal.value = res.data.subtotal || 0
    pesoTotal.value = res.data.peso_total || 0
    pesoTotalKg.value = res.data.peso_total_kg || 0
    bloquesEnvio.value = res.data.bloques_envio || 0
    envio.value = res.data.envio || 0
    total.value = res.data.total || 0
  }

  cargarDelServidor()

  const agregar = async (producto) => {
    const userStore = useUserStore()

    if (!carrito.value.some(p => p.idProduct === producto.idProduct)) {
      await axios.post(`${apiUrl}/cart`, {
        idUser: userStore.user.user.idUser,
        idProduct: producto.idProduct
      })

      await cargarDelServidor()
    }
  }

  const quitar = async (id) => {
    carrito.value = carrito.value.filter(p => p.idCart !== id)

    await axios.delete(`${apiUrl}/cart/${id}`)

    await cargarDelServidor()
  }

  function toggleCarrito() {
    mostrarCarrito.value = !mostrarCarrito.value
  }

  function vaciarCarrito() {
    carrito.value = []
    subtotal.value = 0
    pesoTotal.value = 0
    pesoTotalKg.value = 0
    bloquesEnvio.value = 0
    envio.value = 0
    total.value = 0
  }

  return {
    carrito,
    agregar,
    quitar,
    mostrarCarrito,
    toggleCarrito,
    cargarDelServidor,
    vaciarCarrito,

    subtotal,
    pesoTotal,
    pesoTotalKg,
    bloquesEnvio,
    envio,
    total
  }
})